import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var ExportHelper =
/*#__PURE__*/
function () {
  function ExportHelper() {
    _classCallCheck(this, ExportHelper);
  }

  _createClass(ExportHelper, [{
    key: "downloadCSV",
    value: function downloadCSV(csv, filename) {
      var data, link;
      var blob = new Blob([csv], {
        type: "text/csv;charset=utf-8;"
      });

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");

        if (link.download !== undefined) {
          // feature detection, Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style = "visibility:hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  }]);

  return ExportHelper;
}();

export default new ExportHelper();